// HISTORY screen — renders GET /api/profile/history for a signed-in player.
// Ids are wired in auth.ts (historyBackBtn / historyPlayBtn) and filled by
// auth.ts:showHistory via ui/historyView.ts — keep them.
export const historyHTML = /* html */ `
<div id="screenHistory" class="history hidden">
  <div class="hist-top">
    <button class="icon-btn back" id="historyBackBtn" type="button" aria-label="Back">
      <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false" fill="currentColor"><path d="M11.7 4.3a1.2 1.2 0 0 1 0 1.7L7.7 10l4 4a1.2 1.2 0 1 1-1.7 1.7l-4.8-4.8a1.2 1.2 0 0 1 0-1.7L10 4.3a1.2 1.2 0 0 1 1.7 0Z"/></svg>
    </button>
  </div>
  <h2>Play History</h2>
  <div class="sub" id="historySub">Your recent sessions</div>
  <div class="hist-list" id="historyList"></div>
  <div class="cta" style="margin-top:auto;padding-top:22px;">
    <button class="btn" id="historyPlayBtn">Play a Round</button>
  </div>
</div>`;
